import { useEffect } from 'react';

interface ProposalSEOProps {
  title?: string;
  description?: string;
  companyName?: string;
}

export default function ProposalSEO({
  title = 'Proposta Comercial',
  description = 'Proposta comercial online',
  companyName = 'Eletrônica 2000',
}: ProposalSEOProps) {
  useEffect(() => {
    // Set noindex, nofollow for public proposals
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex, nofollow');

    // Update title
    document.title = `${title} - ${companyName}`;

    // Update description
    let descMeta = document.querySelector('meta[name="description"]');
    if (!descMeta) {
      descMeta = document.createElement('meta');
      descMeta.setAttribute('name', 'description');
      document.head.appendChild(descMeta);
    }
    descMeta.setAttribute('content', description);

    // Cleanup: restore home page SEO on unmount
    return () => {
      if (robotsMeta) {
        robotsMeta.setAttribute('content', 'index, follow');
      }
      document.title = 'Eletrônica 2000 - Portal de Propostas';
      if (descMeta) {
        descMeta.setAttribute(
          'content',
          'Portal de propostas comerciais da Eletrônica 2000. Segurança eletrônica, automação e energia solar desde 1993 em Campo Mourão, PR.'
        );
      }
    };
  }, [title, description, companyName]);

  return null;
}